import Moment from 'moment';

export default {
  validateSearchRules
};

function validateSearchRules(filter) {
  let validation = {
    hasValidSearch: true,
    message: {},
    minSelectionDate: Moment()
      .startOf('day')
      .add(2, 'day')
      .toISOString(),
    maxSelectionDate: Moment()
      .startOf('day')
      .add(345, 'day')
      .toISOString()
  };

  const emptyField = validateEmptyFields(filter);
  if (emptyField) {
    validation.hasValidSearch = false;
    validation.message.code = `home.msg.emptyField.${emptyField}`;
  }

  if (validation.hasValidSearch && validatePassengerSum(filter)) {
    validation.hasValidSearch = false;
    validation.message.code = 'home.msg.qtdPassengerGraterThanMax';
  }

  if (validation.hasValidSearch && validateNoPassenger(filter)) {
    validation.hasValidSearch = false;
  }

  if (validation.hasValidSearch && validateBabysGreaterThanAdults(filter)) {
    validation.hasValidSearch = false;
    validation.message.code = 'home.msg.qtdBabyGraterThanAdults';
  }

  if (validation.hasValidSearch) {
    validateDateRules(filter, validation);
  }

  if (validation.hasValidSearch) {
    validateCabinType(filter, validation);
  }

  return validation;
}

function validateCabinType(filter, validation) {
  let validCabinTypes = ['BUSINESS', 'ECONOMY', '-'];
  if (!validCabinTypes.includes(filter.cabinCategory)) {
    validation.hasValidSearch = false;
    validation.message.code = 'home.msg.invalidCabinCategory';
  }
}

function validateDateRules(filter, validation) {
  validateStartDateRules(filter, validation);

  if (validation.hasValidSearch) {
    validateEndDateRules(filter, validation);
  }
}

function validateStartDateRules(filter, validation) {
  if (validateStartDateBeforeMinDate(filter, validation)) {
    validation.hasValidSearch = false;
    validation.message.code = 'home.msg.startDateBeforeMinDate';
    validation.message.date = Moment(validation.minSelectionDate)
      .subtract(1, 'days')
      .format('DD/MM/YYYY');
  }

  if (validation.hasValidSearch && validateStartDateAfterMaxDate(filter, validation)) {
    validation.hasValidSearch = false;
    validation.message.code = 'home.msg.startDateAfterMaxDate';
    validation.message.date = Moment(validation.maxSelectionDate)
      .add(1, 'days')
      .format('DD/MM/YYYY');
  }
}

function validateEndDateRules(filter, validation) {
  if (filter.typeTrip === 'oneWay') {
    if (filter.endDate) {
      validation.hasValidSearch = false;
      return;
    }
  } else {
    if (validateEndDateBeforeMinDate(filter, validation)) {
      validation.hasValidSearch = false;
      validation.message.code = 'home.msg.endDateBeforeMinDate';
      validation.message.date = Moment(validation.minSelectionDate)
        .subtract(1, 'days')
        .format('DD/MM/YYYY');
    }

    if (validation.hasValidSearch && validateEndDateAfterMaxDate(filter, validation)) {
      validation.hasValidSearch = false;
      validation.message.code = 'home.msg.endDateAfterMaxDate';
      validation.message.date = Moment(validation.maxSelectionDate)
        .add(1, 'days')
        .format('DD/MM/YYYY');
    }
    if (validation.hasValidSearch && validateEndDateBeforeStartDate(filter)) {
      validation.hasValidSearch = false;
      validation.message.code = 'home.msg.endDateBeforeStartDate';
    }
  }
}

function validateEmptyFields(filter) {
  var fields = ['flightOrigin', 'flightDestiny', 'startDate'];
  if (filter.typeTrip === 'roundTrip') {
    fields.push('endDate');
  }

  var emptyField;
  for (var i = 0; i++; i < fields.length) {
    if (!filter[fields[i]]) {
      emptyField = fields[i];
      break;
    }
  }

  return emptyField;
}

function validatePassengerSum(filter) {
  return filter.totalAdults + filter.totalBabys + filter.totalKids > 9;
}

function validateNoPassenger(filter) {
  return filter.totalAdults + filter.totalBabys + filter.totalKids === 0;
}

function validateBabysGreaterThanAdults(filter) {
  return filter.totalBabys > filter.totalAdults;
}

function validateStartDateBeforeMinDate(filter, validation) {
  return Moment(filter.startDate).isBefore(Moment(validation.minSelectionDate));
}

function validateEndDateBeforeMinDate(filter, validation) {
  return Moment(filter.endDate).isBefore(Moment(validation.minSelectionDate));
}

function validateEndDateBeforeStartDate(filter) {
  return Moment(filter.endDate).isBefore(Moment(filter.startDate));
}

function validateStartDateAfterMaxDate(filter, validation) {
  return Moment(filter.startDate).isAfter(Moment(validation.maxSelectionDate));
}

function validateEndDateAfterMaxDate(filter, validation) {
  return Moment(filter.endDate).isAfter(Moment(validation.maxSelectionDate));
}



// WEBPACK FOOTER //
// ./src/services/validation/FlightSearchValidation.js